<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-update`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 4C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm8.264 15.778l-7.072-7.07a1 1 0 00-1.414 0l-7.07 7.07a1 1 0 000 1.414l1.413 1.415a1 1 0 001.415 0l2.962-2.964V32a1 1 0 001 1h2a1 1 0 001-1V21.669l2.937 2.938a1 1 0 001.414 0l1.415-1.415a1 1 0 000-1.414z"/></svg>
</template>
<script>

export default {
  name: 'IconUpdate',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
